import { create } from 'zustand';
import { BaseState } from '../../../shared/stores/storeHelpers';

// Separate interfaces for clear state/actions separation
type UserManagementState = BaseState;

interface UserManagementActions {
  clearError: () => void;
}

export const useUserManagementDataStore = create<
  UserManagementState & UserManagementActions
>(set => {
  return {
    // State
    loading: false,
    error: null,

    // Actions
    clearError: () => set({ error: null }),
  };
});
